/**
 * Wipe shopping-session Pinia + `sessionStorage` when leaving the checkout-active zone
 * (home, success, start, etc.). Staying within personalize ↔ `/checkout` keeps the attempt.
 *
 * Uses {@link useShoppingSessionStore.resetCheckout} (clears ready addresses too — TK-12805).
 *
 * @see `doc/spec/SPEC_shopping_session_lifecycle.md` § Route zones
 */
import { useShoppingSessionStore } from '~~/layers/base/stores/shoppingSession.store'
import { isCheckoutActivePath } from '~~/layers/base/utils/shoppingSessionLifecycle'

export default defineNuxtPlugin(() => {
    const router = useRouter()

    router.afterEach((to, from) => {
        const fromPath = from?.path ?? ''
        const toPath = to.path
        if (isCheckoutActivePath(fromPath) && !isCheckoutActivePath(toPath)) {
            useShoppingSessionStore().resetCheckout()
        }
    })
})
